module.exports = __webpack_public_path__ + "static/media/prick_HMPG_header_image_03_600M.9d4df5d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/prick_HMPG_header_image_03_600M.jpg
// module id = 348
// module chunks = 0